module.exports = __webpack_public_path__ + "static/logohi-5378c0f834e0ca79e087a01eeac29fe0.svg";